// src/components/MenuPage.jsx
import MenuSlider from "./MenuSlider"; 

export default function MenuPage() {
  const desktopSlides = ["/LC_Menu_Back.png", "/LC_Menu.png"];
  const mobileSlides  = [
    "/LC_Menu1.png", "/LC_Menu2.png", "/LC_Menu3.png",
    "/LC_Menu6.png", "/LC_Menu5.png", "/LC_Menu4.png"
  ];

  return (
    <main className="menu-page">
      <div className="menu-desktop">
        <MenuSlider images={desktopSlides} ariaLabel="Full menu slider" />
      </div>
      <div className="menu-mobile">
        <MenuSlider images={mobileSlides} ariaLabel="Mobile menu slider" />
      </div>
    </main>
  );
}

